<ws-modal-wrapper
    [hideSave]="true"
    [headerLabel]="!recipientMode ? header : 'Add CC/BCC Recipients'"
    [loading]="gettingDataForTheFirstTime"
    cancelLabel="Close"
    (cancel)="cancel()"
>
    <div [ngClass]="{ container: !dialogMode }" style="height: 100%">
        <div style="height: 100%">
            <div class="row">
                <div class="col-lg-6 offset-md-3">
                    <div class="input-group">
                        <span class="input-group-text"><i class="fa fa-search"></i></span>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Filter..."
                            [(ngModel)]="filter"
                            (keydown)="checkForEnterKey($event)"
                            (ngModelChange)="validateFilter()"
                        />
                        <button class="ace-btn btn-secondary has-icon" type="button" (click)="clearFilter()">
                            <i class="fa fa-close"></i
                        ></button>
                    </div>
                    @if (filterValidationError !== '') {
                        <div class="alert alert-danger">
                            {{ filterValidationError }}
                        </div>
                    }
                </div>
                @if (filterValidationError !== '') {
                    <div class="alert alert-danger">
                        {{ filterValidationError }}
                    </div>
                }
            </div>
            @if (!(gettingDataForTheFirstTime || contacts.length === 0)) {
                <div style="height: 75%">
                    <div class="mt-4" style="width: 95%">
                        @if (recipientMode) {
                            <button
                                class="ace-btn btn-primary btn-sm"
                                (click)="closeRecipientDialog(recipientTypes.Cc)"
                                style="margin-left: 40px"
                                [disabled]="!atLeastOneSelected"
                            >
                                Add CC
                            </button>
                            <button
                                class="ace-btn btn-primary btn-sm"
                                (click)="closeRecipientDialog(recipientTypes.Bcc)"
                                [disabled]="!atLeastOneSelected"
                            >
                                Add BCC
                            </button>
                        }
                    </div>
                    <!--style="height: 100%;"-->
                    @if (contacts.length > 0) {
                        <div
                            class="row contacts-infinite-scroll"
                            style="margin: 30px; margin-bottom: 0; width: 95%; max-height: 369px; overflow-y: scroll"
                        >
                            <table
                                class="table table-striped table-hover"
                                infinite-scroll="searchContactsOnServer(filter);"
                                infinite-scroll-disabled="gettingDataForTheFirstTime || gettingMoreData"
                                infinite-scroll-immediate-check="false"
                                infinite-scroll-distance="8"
                                infinite-scroll-container='".contacts-infinite-scroll"'
                            >
                                <thead>
                                    <tr>
                                        @if (dialogMode) {
                                            <th style="width: 20px"></th>
                                        }
                                        <th>Name</th>
                                        <th>Title</th>
                                        <th>Phone</th>
                                        <th>Company</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!--contactsAlphaFilter:currentAlphaValue |-->
                                    @for (contact of contacts; track contactsTrackBy($index, contact)) {
                                        <tr>
                                            @if (dialogMode) {
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        [(ngModel)]="contact.selected"
                                                        (ngModelChange)="selectContact(contact)"
                                                    />
                                                </td>
                                            }
                                            <td>
                                                <a
                                                    class="clickable"
                                                    (click)="openContactDialog(contact.contactID, contacts)"
                                                >
                                                    {{ contact.lastName }}, {{ contact.firstName }}
                                                </a>
                                                <ws-ace-loader
                                                    [show]="contact.selected && gettingContactRoles"
                                                    [size]="3"
                                                    [marginTop]="23"
                                                    [marginBottom]="23"
                                                    [hasOverlay]="false"
                                                ></ws-ace-loader>
                                                @if (
                                                    dialogMode &&
                                                    contact.selected &&
                                                    !gettingContactRoles &&
                                                    !recipientMode
                                                ) {
                                                    <div style="margin: 30px; width: 95%; white-space: nowrap">
                                                        <label class="control-label">Role:</label>
                                                        <ws-select
                                                            [options]="
                                                                contact.availableRoles | sortBy: 'asc' : 'roleDesc'
                                                            "
                                                            labelProperty="roleDesc"
                                                            [returnEntireOption]="true"
                                                            [(ngModel)]="contact.selectedRole"
                                                        ></ws-select>
                                                        @if (contact.selectedRole) {
                                                            <button
                                                                style="margin-left: 12px"
                                                                class="ace-btn btn-sm btn-primary"
                                                                (click)="associateRole(contact)"
                                                            >
                                                                Associate
                                                            </button>
                                                        }
                                                        <button
                                                            class="ace-btn btn-sm btn-primary btn-danger"
                                                            (click)="cancelContactAssignRole(contact)"
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                }
                                            </td>
                                            <td>
                                                <span>{{ contact.title }}</span>
                                            </td>
                                            <td>
                                                {{ getAnyContactPhone(contact) }}
                                            </td>
                                            <td>
                                                <a class="clickable" (click)="openCompanyPage(contact.entityID)">
                                                    {{ contact.entityName }}
                                                </a>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                            <ws-ace-loader [show]="gettingMoreData" [hasOverlay]="false"></ws-ace-loader>
                        </div>
                    }
                </div>
            }
            @if (!gettingDataForTheFirstTime && contacts.length == 0) {
                <div class="row" style="text-align: center">
                    <h3 style="padding-top: 60px">No Matching Contacts Found</h3>
                </div>
            }
            @if (!(dialogMode || recipientMode)) {
                <div class="checkbox float-end" style="margin-right: 30px; margin-top: 30px">
                    <input
                        type="checkbox"
                        [(ngModel)]="excludeInactive"
                        (ngModelChange)="searchContactsOnServer(filter, true)"
                    />
                    Exclude Inactive
                </div>
            }
        </div>
    </div>
</ws-modal-wrapper>
